import React, { useEffect, useState } from 'react';
import UseCode from '../../Components/UIComponents/UseCode/UseCode';
import HomePrimaryComp from '../../Components/UIComponents/HomePrimaryComp/HomePrimaryComp';
import './HomePage.css'
import HomeStats from '../../Components/UIComponents/HomeStats/HomeStats';
import BuyEvaluationComp from '../../Components/UIComponents/BuyEvaluationComp/BuyEvaluationComp';
import SetApart from '../../Components/UIComponents/SetApart/SetApart';
import NewsLetter from '../../Components/UIComponents/NewsLetter/NewsLetter';
import GFFTrader from '../../Components/UIComponents/GFFTrader/GFFTrader';
import GenericInfo from '../../Components/UIComponents/GenericInfo/GenericInfo';
import pIcon from '../../assets/images/phone.webp'
import illlus from '../../assets/images/illus.jpg'

function HomePage() {


  const [showVideo, setShowVideo] = useState(window.innerWidth >= 1200);

  useEffect(() => {
    const handleResize = () => {
      setShowVideo(window.innerWidth >= 1100);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div className='homepage__container'>
      <HomePrimaryComp/>
      
       <div className='homepage__inner'>
      {/*  <UseCode/> */}
        

     {/* <div style={{maxWidth:'100vw',overflow:'hidden'}}> */}
   {/*  {showVideo&& <div className="videocont">
  <video className="video" autoPlay loop muted playsInline>
    <source src="/hero.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <img src={illlus} className="videoimage" />
</div>} */}
    {/*  </div> */}
       <HomeStats/>
      <BuyEvaluationComp/>
       <div className='home__introui'>

       </div>
       <GenericInfo
          title={""}
          lefttitle={"Trade on MetaTrader 5 Trading Platform"}
          leftText={`Global Forex Funding Introducing the MetaTrader 5 Trading Platform, designed meticulously for traders of all levels and styles.

MetaTrader 5 enhances your trading with intuitive design and user-friendly features. Benefit from direct data feeds, competitive spreads, low commissions, and no markups. Experience an upgraded trading journey with just a click. Explore MetaTrader 5 and discover the difference firsthand.`}
          /* leftImage={} */ image={pIcon}
        />
       <SetApart/>
       <NewsLetter/>
       <GFFTrader/>

       </div>
    </div>
  );
}

export default HomePage;